<template>


<div>
    <!--Start header-search  area-->
    <section class="header-search">
        <div class="container">
            <div class="row">
                <div class="col-md-12 col-sm-12 col-xs-12">
                    <div  :class="$i18n.locale=='en'?'search-form pull-left':'search-form pull-right'" >
                        <form action="#">

                            <button type="submit"><i class="fa fa-language" aria-hidden="true"></i></button>

                        </form>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <!--End header-search  area-->

    <!--Start header area-->
    <header class="header-area">
        <div class="container">
            <div class="row">
                <div class="col-lg-3 col-md-12 col-sm-12 col-xs-12">
                    <div class="logo">
                        <a :href="$i18n.locale=='en'?'/en':'/ar'"><img :src=" this.serverurl+this.logo"  alt="Awesome Logo"></a>
                    </div>
                </div>
                <div class="col-lg-9 col-md-12 col-sm-12 col-xs-12">
                    <ul class="contact-info">
                       
                        <li>
                            <div class="icon-holder">
                                <span class="flaticon-clock"></span>
                            </div>
                            <div class="content">
                                <h5 :dir="$i18n.locale=='en'?'ltr':'rtl'">
                                    {{ $i18n.locale=='en'?'Service 24/5':'خدمة على مدار 24/5'
}}</h5>
                            </div>
                        </li>
                        <li class="pdleft">
                            <div class="icon-holder">
                                <span class="flaticon-phone-call"></span>
                            </div>
                            <div class="content">
                                <h5><a :href="$i18n.locale=='en'?'../../../../en/contact/':'../../../../ar/contact/'">{{ $i18n.locale=='en'?'Contact US':'للتواصل معنا'
}}</a></h5>
                            </div>
                        </li>
                        <li class="request">
                            <a class="request-quote hvr-sweep-to-bottom" href="https://portal.marketequityinc.com/Login"> {{ $i18n.locale=='en'?'Client Login':'منطقة العملاء' }}</a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </header>
    <!--End header area-->

    <!--Start mainmenu area-->
    <section class="mainmeu-area stricky">
        <div class="container">
            <div :class="$i18n.locale=='en'?'search-button pull-right':'search-button pull-left'" >
                <div class="dropdown mt-5">
                    <button type="button" style="color:#ffffff;background-color: #49B0E1;padding-top: 22px;border:0px;">
                        <span><a @click="langchange($i18n.locale=='en'?'ar':'en' )" href="#" >{{ $i18n.locale=='en'?'ع':'EN' }}</a></span>
                    </button>

                </div>
            </div>
            <div :class="$i18n.locale=='en'?'social-links pull-right':'social-links pull-left'">
                <ul class="footer-social-links">
                    <li><a href="https://www.facebook.com/Wafrafx/"><i aria-hidden="true" class="fa fa-facebook"></i></a></li>
                    <li><a href="https://twitter.com/wafrafx"><i aria-hidden="true" class="fa fa-twitter"></i></a></li>
                    <li><a href="https://www.youtube.com/channel/UCOGqjV7nnQbIWnuiqXYr8yA?view_as=subscriber"><i aria-hidden="true" class="fa fa-youtube"></i></a></li>
                    <li><a href="https://www.instagram.com/wafrafx/"><i aria-hidden="true" class="fa fa-instagram"></i></a></li>
                </ul>
            </div>
            <nav id="nav" :class="$i18n.locale=='en'?'main-menu pull-left':'main-menu pull-right'">
                <div class="navbar-header">
                    <button type="button" class="navbar-toggle" data-toggle="collapse" data-target=".navbar-collapse">
                        <span class="icon-bar"></span>
                        <span class="icon-bar"></span>
                        <span class="icon-bar"></span>
                    </button>
                </div>
                
                <div v-if="$i18n.locale=='en'" class="navbar-collapse collapse clearfix">
<ul class="navigation">
<li class="current"><a :href="'../../../../'+lanflag+'/'">Home</a></li>
<li><a :dir="$i18n.locale == 'en' ?  'ltr': 'rtl'" :style="$i18n.locale == 'en' ?  'text-align: left': 'text-align: right'" :href="'../../../../'+lanflag+'/about'">About Us</a>
</li><li class="dropdown"><a :dir="$i18n.locale == 'en' ?  'ltr': 'rtl'" :style="$i18n.locale == 'en' ?  'text-align: left': 'text-align: right'" :href="'../../../../'+lanflag+'/accounttypes'">Types Of accounts</a>
<ul>
<li><a :dir="$i18n.locale == 'en' ?  'ltr': 'rtl'" :style="$i18n.locale == 'en' ?  'text-align: left': 'text-align: right'" :href="'../../../../'+lanflag+'/accounttypes'">Types Of accounts</a></li>
<li><a :dir="$i18n.locale == 'en' ?  'ltr': 'rtl'" :style="$i18n.locale == 'en' ?  'text-align: left': 'text-align: right'" :href="'../../../../'+lanflag+'/ecn'">ECN Account</a></li>
<li><a :dir="$i18n.locale == 'en' ?  'ltr': 'rtl'" :style="$i18n.locale == 'en' ?  'text-align: left': 'text-align: right'" :href="'../../../../'+lanflag+'/moneyback'">Money Back Account</a></li>
<li><a :dir="$i18n.locale == 'en' ?  'ltr': 'rtl'" :style="$i18n.locale == 'en' ?  'text-align: left': 'text-align: right'" :href="'../../../../'+lanflag+'/scalping'">Scalping Account</a></li>
</ul>
<div class="dropdown-btn"></div></li> 
<li class="dropdown"><a :dir="$i18n.locale == 'en' ?  'ltr': 'rtl'" :style="$i18n.locale == 'en' ?  'text-align: left': 'text-align: right'" :href="'../../../../'+lanflag+'/products'">Products &amp; Services</a>
<ul>
<li><a :dir="$i18n.locale == 'en' ?  'ltr': 'rtl'" :style="$i18n.locale == 'en' ?  'text-align: left': 'text-align: right'" :href="'../../../../'+lanflag+'/products'">Products</a></li>
<li><a :dir="$i18n.locale == 'en' ?  'ltr': 'rtl'" :style="$i18n.locale == 'en' ?  'text-align: left': 'text-align: right'" :href="'../../../../'+lanflag+'/funding'">Funding</a></li>
<li><a :dir="$i18n.locale == 'en' ?  'ltr': 'rtl'" :style="$i18n.locale == 'en' ?  'text-align: left': 'text-align: right'" :href="'../../../../'+lanflag+'/contract'">Contract Specifications</a></li>
</ul>
<div class="dropdown-btn"></div></li>
<li class="dropdown"><a href="#">EDUCATION &amp; RESEARCH</a>
<ul>
<li><a :dir="$i18n.locale == 'en' ?  'ltr': 'rtl'" :style="$i18n.locale == 'en' ?  'text-align: left': 'text-align: right'" :href="'../../../../'+lanflag+'/technical analysis'">Technical Analysis</a></li>
<li><a :dir="$i18n.locale == 'en' ?  'ltr': 'rtl'" :style="$i18n.locale == 'en' ?  'text-align: left': 'text-align: right'" :href="'../../../../'+lanflag+'/glossary'">Glossary</a></li>
<li><a :dir="$i18n.locale == 'en' ?  'ltr': 'rtl'" :style="$i18n.locale == 'en' ?  'text-align: left': 'text-align: right'" :href="'../../../../'+lanflag+'/learningvideos'">Learning Videos</a></li>
<li><a :dir="$i18n.locale == 'en' ?  'ltr': 'rtl'" :style="$i18n.locale == 'en' ?  'text-align: left': 'text-align: right'" :href="'../../../../'+lanflag+'/faq'">FAQ</a></li>
</ul>
<div class="dropdown-btn"></div></li>
<li class="dropdown"><a :href="'../../../../'+lanflag+'/partnership'">Partnership</a>
<ul>
<li><a :dir="$i18n.locale == 'en' ?  'ltr': 'rtl'" :style="$i18n.locale == 'en' ?  'text-align: left': 'text-align: right'" :href="'../../../../'+lanflag+'/partnership'">Partnership With Wafra</a></li>
</ul>
<div class="dropdown-btn"></div></li>
<li><a :dir="$i18n.locale == 'en' ?  'ltr': 'rtl'" :style="$i18n.locale == 'en' ?  'text-align: left': 'text-align: right'" :href="'../../../../'+lanflag+'/contact'">Contact Us</a></li>
</ul>
</div>
                <div v-else class="navbar-collapse collapse clearfix">
                    <ul class="navigation">
                        <li><a :dir="$i18n.locale == 'en' ?  'ltr': 'rtl'" :style="$i18n.locale == 'en' ?  'text-align: left': 'text-align: right'" :href="'../../../../'+lanflag+'/contact'">إتصل بنا</a></li>
                        <li class="dropdown"><a :dir="$i18n.locale == 'en' ?  'ltr': 'rtl'" :style="$i18n.locale == 'en' ?  'text-align: left': 'text-align: right'" :href="'../../../../'+lanflag+'/accounttypes'">أنواع الحسابات</a>
                            <ul>
                                <li><a :dir="$i18n.locale == 'en' ?  'ltr': 'rtl'" :style="$i18n.locale == 'en' ?  'text-align: left': 'text-align: right'" :href="'../../../../'+lanflag+'/accounttypes'">جميع الحسابات</a></li>
                                <li><a :dir="$i18n.locale == 'en' ?  'ltr': 'rtl'" :style="$i18n.locale == 'en' ?  'text-align: left': 'text-align: right'" :href="'../../../../'+lanflag+'/ecn'">ECN حساب</a></li>
                                <li><a :dir="$i18n.locale == 'en' ?  'ltr': 'rtl'" :style="$i18n.locale == 'en' ?  'text-align: left': 'text-align: right'" :href="'../../../../'+lanflag+'/moneyback'">حساب العوائد المالية</a></li>
                                <li><a :dir="$i18n.locale == 'en' ?  'ltr': 'rtl'" :style="$i18n.locale == 'en' ?  'text-align: left': 'text-align: right'" :href="'../../../../'+lanflag+'/scalping'">Scalping حساب</a></li>
                            </ul>
                        </li>
                        <li class="dropdown"><a :dir="$i18n.locale == 'en' ?  'ltr': 'rtl'" :style="$i18n.locale == 'en' ?  'text-align: left': 'text-align: right'" :href="'../../../../'+lanflag+'/products'">منتجات و خدمات</a>
                            <ul>
                                <li><a :dir="$i18n.locale == 'en' ?  'ltr': 'rtl'" :style="$i18n.locale == 'en' ?  'text-align: left': 'text-align: right'" :href="'../../../../'+lanflag+'/products'">المنتجات</a></li>
                                <li><a :dir="$i18n.locale == 'en' ?  'ltr': 'rtl'" :style="$i18n.locale == 'en' ?  'text-align: left': 'text-align: right'" :href="'../../../../'+lanflag+'/funding'">تمويل الحساب</a></li>
                                <li><a :dir="$i18n.locale == 'en' ?  'ltr': 'rtl'" :style="$i18n.locale == 'en' ?  'text-align: left': 'text-align: right'" :href="'../../../../'+lanflag+'/contract'">مواصفات العقود</a></li>
                            </ul>
                        </li>
                        <li class="dropdown"><a href="#">البحث و التعليم</a>
                            <ul>
                                <li><a :dir="$i18n.locale == 'en' ?  'ltr': 'rtl'" :style="$i18n.locale == 'en' ?  'text-align: left': 'text-align: right'" :href="'../../../../'+lanflag+'/technical analysis'">التحليلات الفنية</a></li>
                                <li><a :dir="$i18n.locale == 'en' ?  'ltr': 'rtl'" :style="$i18n.locale == 'en' ?  'text-align: left': 'text-align: right'" :href="'../../../../'+lanflag+'/glossary'">المعجم</a></li>
                                <li><a :dir="$i18n.locale == 'en' ?  'ltr': 'rtl'" :style="$i18n.locale == 'en' ?  'text-align: left': 'text-align: right'" :href="'../../../../'+lanflag+'/learningvideos'">الفيديوهات التعليمية</a></li>
                                <li><a :href="'../../../../'+lanflag+'/faq'">الأسئلة الشائعة</a></li>
                            </ul>
                        </li>
                        <li class="dropdown"><a href="#">الشراكة</a>
                            <ul>
                                <li><a :dir="$i18n.locale == 'en' ?  'ltr': 'rtl'" :style="$i18n.locale == 'en' ?  'text-align: left': 'text-align: right'" :href="'../../../../'+lanflag+'/partnership'">الشراكة مع وفرة</a></li>

                            </ul>
                        </li>
                        <li><a :dir="$i18n.locale == 'en' ?  'ltr': 'rtl'" :style="$i18n.locale == 'en' ?  'text-align: left': 'text-align: right'" :href="'../../../../'+lanflag+'/about'">من نحن</a>
                        <li class="current"><a :dir="$i18n.locale == 'en' ?  'ltr': 'rtl'" :style="$i18n.locale == 'en' ?  'text-align: left': 'text-align: right'"  :href="'../../../../'+lanflag+'/'">الرئيسية</a></li>
                    </ul>
                </div>
            </nav>


        </div>

    </section>
</div>
</template>
<script>

</script>
<script>

export default {
    name: 'header',
    data() {
        return {
            langs: ['en', 'ar'], language: 'en',
            logo: null,
            sitetitleen: null,
            sitetitlear: null,
            sitetitlech: null,
            sitetitlefr: null,
            locale:'en',
            mainmenus:'',
            submenus:'',
            lanflag:'en',
            routeurl:'',
            pathname:'',
            host:location.host,
             tickerdata:'',
            olddata:'',
            newdata:'',
            bidClassName:''



        }
    },

   created() {


    },
    beforeMount() {

        this.loaddata();
        this.loadmenus();
        this.routeurl=window.location.pathname;

        var pathvalues=(this.$route.path).split("/");
        this.pathname=pathvalues[2];

        var pathvalues = (this.$route.path).split("/");

//alert(pathvalues[1]);
        if (pathvalues[1] == 'en') {
            this.$i18n.locale = 'en';
            this.lanflag='en';


  var d = document.getElementById("nav");
  d.classList.add("pull-left");

var allMetaElements = document.getElementsByTagName('meta');
//loop through and find the element you want
                for (var i = 0; i < allMetaElements.length; i++) {

                    if (allMetaElements[i].getAttribute("name") == "description") {
                        //make necessary changes
                        allMetaElements[i].setAttribute('content', "The world’s safest trading platform in CFDs, commodities, currencies and stocks. Market Equity allows you to trade a minimum deposit of $100 with a Leverage up to 1: 500");
                        //no need to continue loop after making changes.
                       // break;
                    }
                     if (allMetaElements[i].getAttribute("name") == "keywords") {
                        //make necessary changes
                        allMetaElements[i].setAttribute('content', "gold,broker,stock markets,currencies,trading,mt5,mt4,cryptocurrencies,CFDs,stocks,Commodity,Forex,technical analysis,average,Market Equity,shares,Market,Marketplace,Seminar,Financial market,stock market,online trading,trading for beginners,Equity,spreads,Market Equity,share market today,United States Dollar,webinar online,types of accounts,online trading platforms");
                        //no need to continue loop after making changes.
                       // break;
                    }
                }



        }
        if (pathvalues[1] == 'ar') {
            this.$i18n.locale = 'ar';
            this.lanflag='ar';
           // document.getElementById("fp-nav").className = "left";
            //document.getElementById("nav").className = "main-menu pull-right";
         var d = document.getElementById("nav");
  d.classList.add("pull-right");
              var allMetaElements = document.getElementsByTagName('meta');
//loop through and find the element you want
                for (var i = 0; i < allMetaElements.length; i++) {

                    if (allMetaElements[i].getAttribute("name") == "description") {
                        //make necessary changes
                        allMetaElements[i].setAttribute('content', "تداول الاسهم مفابل الفروقات و العملات الأجنبية و جميع الأسهم و السلع و المؤشرات. تضمن ماركت إكويتي منصة تداول آمنة و عالية الجودة");
                        //no need to continue loop after making changes.
                       // break;
                    }
                     if (allMetaElements[i].getAttribute("name") == "keywords") {
                        //make necessary changes
                        allMetaElements[i].setAttribute('content', "تداول الفوركس,تداول,نفط,CFD,CFDs,منصة تداول,العملات المشفرة,تجارة الفوركس,سوق الاسهم,الأسهم,البورصة,عملات رقمية,ب,الذهب,أسعار الذهب,اسعار الذهب,Mt4 trading,Mt5,تداول الذهب,تداول النفط,تداول الاسهم,اكويتي,فوركس,ماركت إكويتي,Market Equity,اونلاين,تعلم التداول,التداول اونلاين,Zoom meeting,اقتصاد,محفظة مالية,الإقتصاد,الدولار الامريكي,الباوند,سلع ,السلع,محاضرة,استثمار,شركة ماركت إيكويتي");
                        //no need to continue loop after making changes.
                       // break;
                    }
                }




        }
      
        // this.$i18n.locale=pathvalues[1];
        this.pagenameroute = pathvalues[2];
      //  this.ticker();

    },

    methods: {
                   ticker(){

            // var oldData = null;
            // var newData =null;

            var data = null;
            //setInterval(initAjax, 10000);

            this.$axios.get("loadtickerdata",
            )
                .then(response => {

                    var result = response;
                    data = result.data.data.data;

                    this.olddata = this.newdata;
                    this.newdata = data;

                   // this.tickerdata=null;
                    this.tickerdata=data;

                    console.log(data)

                    for(var i = 0; i < data.length; i++){

                        if(this.olddata){


                            this.tickerdata[i]['bidclass'] = data[i].Bid < this.olddata[i].Bid ? 'low' :  'high';

                        }

                       
                    }
                  

                });



        },


        loaddata() {

            this.$axios.get("loadheaderdata",
            )
                .then(res => {
                    if (res) {

                        this.logo = res.data.sitesettings[0].logo;
                        this.sitetitleen = res.data.sitesettings[0].sitetitleen;
                        this.sitetitlear = res.data.sitesettings[0].sitetitlear;
                       

                    }
                });
        },
        loadmenus() {

            this.$axios.get("loadmenus",
            )
                .then(res => {
                    if (res) {

                        this.mainmenus = res.data.mainmenus;
                        this.submenus = res.data.submenus;


                    }
                });
        },
        langchange(lang) {
           this.$i18n.locale=lang;
            if (lang == 'en') {
                document.title = this.sitetitleen;
                document.dir = "ltr";
                this.lanflag='en';
                 document.getElementById("fp-nav").className = " right";
               
                for (var i = 0; i < allMetaElements.length; i++) {

                    if (allMetaElements[i].getAttribute("name") == "description") {
                        //make necessary changes
                        allMetaElements[i].setAttribute('content', "The world’s safest trading platform in CFDs, commodities, currencies and stocks. Market Equity allows you to trade a minimum deposit of $100 with a Leverage up to 1: 500");
                        //no need to continue loop after making changes.
                       // break;
                    }
                     if (allMetaElements[i].getAttribute("name") == "keywords") {
                        //make necessary changes
                        allMetaElements[i].setAttribute('content', "gold,broker,stock markets,currencies,trading,mt5,mt4,cryptocurrencies,CFDs,stocks,Commodity,Forex,technical analysis,average,Market Equity,shares,Market,Marketplace,Seminar,Financial market,stock market,online trading,trading for beginners,Equity,spreads,Market Equity,share market today,United States Dollar,webinar online,types of accounts,online trading platforms");
                        //no need to continue loop after making changes.
                       // break;
                    }
                }



            }
            if (lang == 'ar') {
this.$i18n.locale=lang;
                document.title = this.sitetitlear;
                document.dir = "rtl";
                this.lanflag='ar';
                document.getElementById("fp-nav").className = "left";
               
                  var allMetaElements = document.getElementsByTagName('meta');
//loop through and find the element you want
                for (var i = 0; i < allMetaElements.length; i++) {

                    if (allMetaElements[i].getAttribute("name") == "description") {
                        //make necessary changes
                        allMetaElements[i].setAttribute('content', "تداول الاسهم مفابل الفروقات و العملات الأجنبية و جميع الأسهم و السلع و المؤشرات. تضمن ماركت إكويتي منصة تداول آمنة و عالية الجودة");
                        //no need to continue loop after making changes.
                       // break;
                    }
                     if (allMetaElements[i].getAttribute("name") == "keywords") {
                        //make necessary changes
                        allMetaElements[i].setAttribute('content', "تداول الفوركس,تداول,نفط,CFD,CFDs,منصة تداول,العملات المشفرة,تجارة الفوركس,سوق الاسهم,الأسهم,البورصة,عملات رقمية,ب,الذهب,أسعار الذهب,اسعار الذهب,Mt4 trading,Mt5,تداول الذهب,تداول النفط,تداول الاسهم,اكويتي,فوركس,ماركت إكويتي,Market Equity,اونلاين,تعلم التداول,التداول اونلاين,Zoom meeting,اقتصاد,محفظة مالية,الإقتصاد,الدولار الامريكي,الباوند,سلع ,السلع,محاضرة,استثمار,شركة ماركت إيكويتي");
                        //no need to continue loop after making changes.
                       // break;
                    }
                }
            }
           

        }
    }

}


</script>


